jQuery(function ($) {
    if ( $('.gallery-container').length ) {
        var slider = tns({
            container: '.gallery-container',
            items: 1,
            autoplay: false,
            slideBy: 1,
            autoHeight: false,
            autoplayButtonOutput: false,
            speed: 700,
            controlsText: ["", ""],
            navPosition: 'bottom',
            center: true,
            lazyload: true,
            lazyloadSelector: '.gallery-container img'
        });
    }
});